import Account from '@/components/b2b/Account';
import Eligibility from '@/components/b2b/Eligibility';
import Error from '@/components/b2b/Error';
import Renew from '@/components/b2b/Renew';
import RequestAccess from '@/components/b2b/RequestAccess';
import AccessSuccess from '@/components/b2b/RequestAccess/Success';
import Sorry from '@/components/b2b/Sorry';
import Success from '@/components/b2b/Success';
import PathwaysSuccess from '@/components/b2b/Success/PathwaysSuccess';
import Welcome from '@/components/b2b/Welcome';

import { SignupScreenProps, SignupScreensKey } from '../shared/types';

export const signupScreens: Record<
	SignupScreensKey,
	{ readonly Component: React.FC<SignupScreenProps>; readonly name: string }
> = {
	accessSuccess: {
		Component: AccessSuccess,
		name: 'B2B : Request Access Success',
	},
	account: {
		Component: Account,
		name: 'B2B : Account',
	},
	eligibility: {
		Component: Eligibility,
		name: 'B2B : Eligibility',
	},
	error: {
		Component: Error,
		name: 'B2B : Error',
	},
	pathwaysSuccess: {
		Component: PathwaysSuccess,
		name: 'B2B : Request Pathways Success',
	},
	renew: {
		Component: Renew,
		name: 'B2B : Renew',
	},
	requestAccess: {
		Component: RequestAccess,
		name: 'B2B : Request Access',
	},
	sorry: {
		Component: Sorry,
		name: 'B2B : Sorry',
	},
	success: {
		Component: Success,
		name: 'B2B : Success',
	},
	welcome: {
		Component: Welcome,
		name: 'B2B : Welcome',
	},
} as const;
